var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCartRollerRegular = function SvgCartRollerRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 4.75c.3 0 .574.246.629.547l.055.328h11.484c.574 0 1.012.574.848 1.121l-1.477 5.25a.854.854 0 0 1-.848.629H8.773l.247 1.313h8.449c.355 0 .656.3.656.656 0 .383-.3.656-.656.656H8.473a.644.644 0 0 1-.63-.52l-1.64-8.668H4.781a.632.632 0 0 1-.656-.656c0-.355.273-.656.656-.656H6.75Zm10.363 6.563 1.23-4.376H7.708l.82 4.375h8.586Zm-9.488 6.124c0-.71.574-1.312 1.313-1.312.71 0 1.312.602 1.312 1.313 0 .738-.602 1.312-1.313 1.312a1.296 1.296 0 0 1-1.312-1.313Zm10.5 0c0 .739-.602 1.313-1.313 1.313a1.296 1.296 0 0 1-1.312-1.313c0-.71.574-1.312 1.313-1.312.71 0 1.312.602 1.312 1.313Z"
  })));
};

export default SvgCartRollerRegular;